import { render, staticRenderFns } from "./ValidatedAndNotAllStemdoersAvailableGroup.vue?vue&type=template&id=85f81956"
import script from "./validatedAndNotAllStemdoersAvailableGroup.ts?vue&type=script&lang=ts&external"
export * from "./validatedAndNotAllStemdoersAvailableGroup.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports